import ScoreDifference from '../ScoreDifference';
import SuggestedImprovement from '../SuggestedImprovement';
import styles from './CompareCompetenceList.module.scss';

interface CompareCompetenceListProps {
  competences: {
    competence: string;
    firstPoints: number;
    secondPoints: number;
    suggested: string;
  }[];
}

function CompareCompetenceList({competences}: CompareCompetenceListProps) {
  return (
    <>
      {competences.map((competences) => {
        const competenceDiff =
          competences.secondPoints - competences.firstPoints;

        return (
          <article className={styles.mobileCard} key={competences.competence}>
            <header>
              <h2>{competences.competence}</h2>
            </header>

            <div className={styles.mobileCardContent}>
              <div className={styles.mobileScores}>
                <div>
                  <h3>1ª nota</h3>
                  <p>{competences.firstPoints}</p>
                </div>

                <div>
                  <h3>2ª nota</h3>
                  <p>{competences.secondPoints}</p>
                </div>

                <div>
                  <h3>Diferença</h3>
                  <p
                    data-diff={
                      competenceDiff !== 0 &&
                      (competenceDiff > 0 ? 'positive' : 'negative')
                    }
                  >
                    {competenceDiff > 0 ? '+' : ''}
                    {competenceDiff}
                  </p>
                </div>
              </div>

              <ScoreDifference
                hideDifference
                firstPoints={competences.firstPoints}
                secondPoints={competences.secondPoints}
              />
            </div>

            <div className={styles.mobileCardFooter}>
              <h3>Como melhorar</h3>
              <SuggestedImprovement
                suggestedImprovement={competences.suggested}
              />
            </div>
          </article>
        );
      })}
    </>
  );
}

export default CompareCompetenceList;
